import { getPolyfills as getWindowPolyfills } from './polyfills/window';

const loadPolyfills: () => Promise<any[]> = async () => {
  const polyfills: Promise<any>[] = [];

  polyfills.push(...getWindowPolyfills());

  if (typeof PromiseRejectionEvent !== 'function') {
    window.PromiseRejectionEvent = class PromiseRejectionEvent extends Event {
      public readonly promise: Promise<any>;
      public readonly reason: any;

      constructor(type: string, eventInitDict: PromiseRejectionEventInit) {
        super(type);

        this.promise = eventInitDict.promise;
        this.reason = eventInitDict.reason;
      }
    };
  }

  return Promise.all(polyfills);
};

export default loadPolyfills;
